/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "analytics/analytics";
import facebookEvents from "analytics/facebook-events";
import doubleclickEvents from "analytics/doubleclick-events";
import environment from "modules/environment";
import userProfiler from "modules/userprofiler";
import browser from "utils/browser";

export default baustein.register("new-email-capture-page", {
    defaultOptions: {
        captureType: "unknown",
        alertForId: null
    },

    setupEvents(add) {
        add("submit", ".new-email-capture__form", this.onSubmitSuccess);
    },

    init() {
        if (!this.isMobile()) {
            return;
        }

        // else email-capture-overlay does this
        var email = userProfiler.userProfile.user.email;
        if (email) {
            this.setEmailAddress(email);
        }
    },

    setEmailAddress(emailAddress) {
        const input = this.el.querySelector('input[name="email"]');
        if (input) {
            input.value = emailAddress;
        }
    },

    isMobile() {
        return browser.getViewport() === browser.VIEWPORTS.MOBILE;
    },

    onSubmitSuccess() {
        if (!this.isMobile()) {
            return;
        }
        if (this.options.captureType === "designer_update") {
            userProfiler.saveDesignerUpdate(this.options.alertForId);
        } else if (this.options.captureType === "stock_alert") {
            userProfiler.saveStockAlert(this.options.alertForId);
        } else if (this.options.captureType === "anon_lyst") {
            userProfiler.saveLystedProduct(this.options.alertForId);
        } else if (this.options.captureType == "search_subscription") {
            userProfiler.saveSubscribedSeachTerm(this.options.alertForId);
        }
        this.processSuccess(this.options.captureType);
    },

    processSuccess(eventAction) {
        analytics.event("email_capture", "created", eventAction);
        analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.EMAIL_SIGNUP);
        analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, doubleclickEvents.ANON_SIGN_UP, {
            atc_country: environment.get("country")
        });
    }
});

